module.exports = __webpack_public_path__ + "img/ico-prostate-cancer-90-x-90.762f509b.svg";